import { render, staticRenderFns } from "./DatalistSuggestSelector.vue?vue&type=template&id=638579bc&scoped=true&"
import script from "./DatalistSuggestSelector.vue?vue&type=script&lang=ts&"
export * from "./DatalistSuggestSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638579bc",
  null
  
)

export default component.exports